import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, Observable, throwError } from 'rxjs';
import { SUPPRESS_GLOBAL_ERROR_NAVIGATION } from './suppress-global-error';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private router = inject(Router);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // A caller that renders its own failure UI opts out of the global navigation: navigating
        // would destroy the component before it could show "not found" / "unable to load". The
        // error is rethrown either way, so opting out never hides a failure — it only decides who
        // presents it. 401 is deliberately NOT opt-out-able: an expired session has to reach the
        // sign-in flow no matter which screen noticed it first.
        if (error.status === 401) {
          void this.router.navigate(['/unauthorized']);
        } else if (!request.context.get(SUPPRESS_GLOBAL_ERROR_NAVIGATION)) {
          void this.router.navigate(['/error']);
        }

        // Always rethrown: opting out of the redirect opts out of the *navigation*, not of the
        // error itself, which the caller still has to handle.
        return throwError(() => error);
      }),
    );
  }
}
